/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function CitilogIncidentExtractedReducer
 *  *
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeCitilogIncidentExtractedAction } action:
 *     action de l'application
 * @return { Reducer }
 */
export const CitilogIncidentExtractedReducer:
    Reducer<CombinesObjectModels<any>> =
        (state: any =
             {

             },
         action: actionsTypesFromStore.TypeCitilogIncidentExtractedAction) => {
          switch (action.type) {
            case actions.CitilogIncidentExtractedActionTypes
                .CITILOGINCIDENTEXTRACTED_INPROGRESS:

              return {
                loading: true, ...state
              }

              break;
            case actions.CitilogIncidentExtractedActionTypes
                .CITILOGINCIDENTEXTRACTED_FAIL:

              return {
                error: action.payload.error, loading: false,
              }

              break;

            case actions.CitilogIncidentExtractedActionTypes
                .CITILOGINCIDENTEXTRACTED_SUCCESS:

              return {
                data: action.payload.data, loading: false,
              }

              break;

            default:
              return state
              break;
          }
        }


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/tools/citilogIncident/extract/index.ts